



































import { COLLECTION_ORGANIZATIONS, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import StatusType from '@/model/typelist/StatusType';
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class Members extends Vue {
  dis = false;

  mounted() {
    if (this.fmembers.length) {
      const mem = this.objToString(this.fmembers);
      this.$store.dispatch('bindOrgMembers', mem);
    }
  }
  // eslint-disable-next-line
  objToString(mems: any[]) {
    return mems.map((m: any) => m.id);
  }

  get fmembers() {
    return this.org.members
      .filter((m: any) => m.status.code === 'approved');
  }

  role(item: any) {
    return this.fmembers.find((m: any) => m.id === item.uid).status.name;
  }

  showUserProfile(id: any) {
    this.$router.push(`/userProfile/${id}`);
  }

  accepted(item: any) {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    const index = clone.members.findIndex((m: any) => m.id === item.uid);
    clone.members[index].status = { ...StatusType.approved };
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: clone,
    });
    this.dis = true;
  }

  deleted(item: any) {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    const index = clone.members.findIndex((m: any) => m.id === item.uid);
    clone.members[index].status = { ...StatusType.rejected };
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: clone,
    });
    this.dis = true;
  }

  get org() {
    return this.$store.state.orgObj;
  }

  get approvedList() {
    return this.$store.state.orgMembers;
  }
}
